import React, { useState, useEffect } from 'react';
import ReactMinimalPieChart from 'react-minimal-pie-chart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

function Social({ score, displayFormula, analysis, skills, lengthValue }) {
  const [tweet, setTweet] = useState('');

  const CHART_DATA = [
    {
      title: 'Hard & Soft Skills',
      color: '#f9423a',
      value: Math.min(Math.round(skills?.length * 9.33), 28),
    },
    {
      title: 'Job Title',
      color: '#0072ce',
      value: analysis?.title ? 18 : 0,
    },
    {
      title: 'Measurable Results',
      color: '#ffbd59',
      value: analysis?.metrics ? 18 : 0,
    },
    {
      title: '"I Help" Pitch',
      color: '#7fd959',
      value: analysis?.valueProp ? 18 : 0,
    },
    {
      title: '"Headline Length',
      color: '#c6d0d8',
      value: lengthValue,
    },
    {
      title: '',
      value: 100 - Number(score),
      color: 'rgba(0, 0, 0, 0.1)',
    },
  ];

  useEffect(() => {
    setTweet(
      'I got a ' +
        score +
        " on Cultivated Culture's #LinkedInHeadlineAnalyzer! Check it out: https://cultivatedculture.com/headline-analyzer"
    );
  }, [score]);

  return (
    <div className={displayFormula ? 'py-5 px-sm-5 bg-light' : 'py-5 px-sm-5'}>
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h1 className="font-weight-bold text-center">
            Share Your New Headline On LinkedIn!
          </h1>
        </div>
        <h6 className="text-center my-2">
          You're out here writing killer LinkedIn headlines - share your work
          with friends, colleagues, recruiters, or anyone else who might
          benefit:
        </h6>
        <div className="row pt-3">
          <div className="col-12 col-md d-flex align-items-center justify-content-center mb-4 mb-sm-0">
            <div className="hachart position-relative">
              <ReactMinimalPieChart
                animate
                animationDuration={500}
                animationEasing="ease-out"
                cx={50}
                cy={50}
                data={CHART_DATA}
                label={false}
                lengthAngle={360}
                lineWidth={25}
                onClick={undefined}
                onMouseOut={undefined}
                onMouseOver={undefined}
                paddingAngle={2}
                radius={50}
                rounded={false}
                startAngle={-90}
                viewBoxSize={[100, 100]}
              />
              <div className="graph-label mt-2">
                <h1 className="font-weight-bold text-center d-block margin-override">
                  {score}
                </h1>
                <p className="text-center d-block">
                  <span className="font-override">Headline Score</span>
                </p>
              </div>
            </div>
          </div>
          <div className="col">
            <textarea
              className="habox"
              id="haBox"
              defaultValue={tweet}
              onChange={e => setTweet(e.target.value)}
            />
            <div className="ml-sm-5">
              <div className="row mt-2">
                <div className="col-12 col-xl-4 my-2">
                  <div className="row">
                    <a
                      href={
                        'https://twitter.com/intent/tweet?url=https://cultivatedculture.com/headline-analyzer-analyzer&hashtags=LinkedInHeadlineAnalyzer&text=' +
                        tweet.replace(' ', '%20')
                      }
                      className="mx-auto btn btn-primary mx-sm-0 text-decoration-none font-weight-bold"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faTwitter} /> TWITTER
                    </a>
                  </div>
                </div>
                <div className="col-12 col-xl-4 my-2">
                  <div className="row">
                    <a
                      href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fcultivatedculture.com%headline-analyzer%2F"
                      className="mx-auto btn btn-primary mx-sm-0 text-decoration-none font-weight-bold"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faLinkedin} /> LINKEDIN
                    </a>
                  </div>
                </div>
                <div className="col-12 col-xl-4 my-2">
                  <div className="row">
                    <a
                      href="http://www.facebook.com/sharer.php?u=https://cultivatedculture.com/headline-analyzer"
                      className="mx-auto btn btn-primary mx-sm-0 text-decoration-none font-weight-bold"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faFacebookF} /> FACEBOOK
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Social;
